module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "rankTitle",
    attrs: {
      "id": "rankTitle"
    }
  }, [_c('i', {
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/goback_1.png")
    }
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.singerList[_vm.rankPageIndex].name))])]), _vm._v(" "), _c('div', {
    staticClass: "rankHead",
    style: ({
      'background-image': 'url(' + _vm.singerImg + ')'
    })
  }, [_c('div', {
    staticClass: "plistText"
  }, [_vm._v(_vm._s(_vm.shortSingerInfo))])]), _vm._v(" "), _c('v-songlist')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a485752"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/singer_info.vue
// module id = 94
// module chunks = 0